import { Image, Tweet, TweetReply } from '~/api-definition/definition'
import { config } from '~/config'

export type TweetOrReply =
  | { type: 'tweet'; value: Tweet }
  | { type: 'reply'; value: TweetReply }

export const tweetHtmlId = (tweetOrReply: TweetOrReply) => {
  if (tweetOrReply.type === 'tweet') {
    return `tweet-${tweetOrReply.value.tweetId}`
  } else {
    return `reply-${tweetOrReply.value.tweetReplyId}`
  }
}

export const tweetImageToSrc = (image: Image) => {
  return {
    try: image.imageUrl,
    fallback: config.noImageUrl.tweetImage,
  }
}
